import React from 'react';
import { Redirect } from 'react-router-dom';

export const RedirectToCheckoutHandler = ({ to }) => {
  return <Redirect to={`/redirect-to-checkout?redirect_url=${encodeURIComponent(to)}`} />;
};

export default RedirectToCheckoutHandler;
